<template>
  <div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-lg-4 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-content">
            <vue-dropzone ref="uploadZone" id="dropzone" :options="dropzoneOptions"
              v-on:vdropzone-sending="uploadUploading" v-on:vdropzone-complete-multiple="filesBeingUploaded = false"
              v-on:vdropzone-success="uploadSuccess" style="font-family: 'Roboto', Arial, Verdana"></vue-dropzone>
            <hr />
            <fieldset>
              <div class="form-group">
                <div class="col-sm-12">
                  <textarea class="form-control" v-model="uploadData.message"
                    :placeholder="$t('special_instructions_put_here')" rows="3"></textarea>
                </div>
              </div>
            </fieldset>
            <div class="col-md-12 col-sm-12 col-xs-12">
              <hr />
              <h4>{{ $t("selected_main_tuning_type") }}</h4>
              <table class="table">
                <thead>
                  <th scope="col" width="80%">{{ $t("name") }}</th>
                  <th scope="col">{{ $t("credits") }}</th>
                </thead>
                <tr>
                  <td>
                    {{ selectedTuningType.long_name }}
                    <small v-if="selectedTuningType.content" v-html="selectedTuningType.content"></small>
                  </td>
                  <td style="vertical-align:top; font-weight:bold;">{{ selectedTuningType.credits }}</td>
                </tr>
              </table>
              <div v-if="selectedChildren.length > 0">
                <h4>{{ $t("additional_tuning_types") }}</h4>
                <table class="table table-responsive">
                  <thead>
                    <th scope="col" width="80%">{{ $t("name") }}</th>
                    <th scope="col">{{ $t("credits") }}</th>
                  </thead>
                  <tr v-for="selectedChild in selectedChildren" :key="selectedChild">
                    <td v-if="selectableChildren[selectedChild]">
                      {{ selectableChildren[selectedChild].short_name
                      }}<small v-if="selectableChildren[selectedChild].content"
                        v-html="selectableChildren[selectedChild].content"></small>
                    </td>
                    <td  style="vertical-align:top; font-weight:bold;" v-if="selectableChildren[selectedChild]">{{ selectableChildren[selectedChild].credits }}</td>
                  </tr>
                </table>
              </div>
              <div v-if="selectedPriority">
                <h4>{{ $t("priority_options") }}</h4>
                <table class="table table-responsive">
                  <thead>
                    <th scope="col" width="80%">{{ $t("name") }}</th>
                    <th scope="col">{{ $t("credits") }}</th>
                  </thead>
                  <tr>
                    <td>
                      {{ selectedPriority.short_name
                      }}<small v-if="selectedPriority.content" v-html="selectedPriority.content"></small>
                    </td>
                    <td>{{ selectedPriority.credits }}</td>
                  </tr>
                </table>
              </div>
              <table class="table table-responsive totalCreditsTable">
                <tr>
                  <th scope="col" width="80%">{{ $t("total_credits") }}</th>
                  <th scope="col">{{ calculateTotalCredits }}</th>
                </tr>
              </table>
              {{ $t("credits_may_be_changed") }}
              <strong>{{ $t("indication") }}</strong>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
        <div class="card">
          <div class="card-content">
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("vehicle_type")
              }}</label>
              <el-select :class="{
                'select-warning': !uploadData.vehicle_type,
                'select-success': uploadData.vehicle_type,
              }" class="col-md-4" size="large" :placeholder="$t('select_vehicle_type')"
                v-model="uploadData.vehicle_type" v-validate="'required'" name="vehicle type"
                @change="loadBrands($event)">
                <el-option v-for="vehicletype in vehicleData.types" :value="vehicletype.value" :key="vehicletype.value">{{
                  $t(vehicletype.name) }}</el-option>
              </el-select>
              <el-select class="col-md-4 select-success" size="large" :placeholder="$t('select_priority')"
                v-model="uploadData.priority" name="priority" @change="priorityChanged($event)">
                <el-option name="default" value="">default (normal)</el-option>
                <el-option v-for="(priority, key) in priorities" :value="priority.id" :label="priority.short_name"
                  :key="key"></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("requested_tuning_fuel")
              }}</label>
              <el-select :class="{
                'select-warning': !uploadData.tuning_type,
                'select-success': uploadData.tuning_type,
              }" class="col-md-4" size="large" :placeholder="$t('select_tuning_type')"
                v-model="uploadData.tuning_type" v-validate="'required'" name="tuning type"
                @change="tuningTypeChanged($event)">
                <el-option v-for="(tuningtype, key) in tuningTypes" class="select-primary" :value="tuningtype.id" :label="
                  tuningtype.short_name +
                  ' (' +
                  tuningtype.credits +
                  ' credits)'
                " :key="key" v-if="
  !tuningtype.is_child && (uploadData.vehicle_type == tuningtype.vehicle_type ||
    tuningtype.vehicle_type == 'all')
"></el-option>
              </el-select>
              <el-select :class="{
                'select-warning': !uploadData.fuel_type,
                'select-success': uploadData.fuel_type,
              }" class="col-md-4" size="large" :placeholder="$t('select_fuel_type')" v-model="uploadData.fuel_type"
                v-validate="'required'" name="fuel type">
                <el-option class="select-primary" value="Gasoline" :label="$t('gasoline')"></el-option>
                <el-option class="select-primary" value="Diesel" :label="$t('diesel')"></el-option>
                <el-option class="select-primary" value="LPG" :label="$t('lpg')"></el-option>
                <el-option class="select-primary" value="Hybrid" :label="$t('hybrid')"></el-option>
                <el-option class="select-primary" value="Electric" :label="$t('electric')"></el-option>
                <el-option class="select-primary" value="Other/Unknown" :label="$t('other_unknown')"></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <div v-if="selectableChildren.length > 0">
                <label class="col-md-4 control-label">{{ $t('select_additional_tuning_types_multiple_allowed') }}
                  <span class="optionalText"></span></label>
                <el-select :class="{ 'select-success': uploadData.tuning_type }" class="col-md-8" size="large"
                  :placeholder="$t('select_additional_tuning_types')" v-model="selectedChildren" multiple
                  name="additional tuning type" filterable @change="checkCreditSufficiency()">
                  <el-option v-for="(selectableChild, key) in selectableChildren" class="select-primary" :value="key"
                    :label="
                      selectableChild.short_name +
                      ' (' +
                      selectableChild.credits +
                      ' credits)'
                    " :key="key"></el-option>
                </el-select>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group" v-if="!manualData">
              <label class="col-md-4 control-label">{{ $t('vehicle_brand_series') }}</label>
              <el-select :class="{
                'select-warning': !uploadData.vehicle_brand,
                'select-success': uploadData.vehicle_brand,
              }" class="col-md-4" size="large" :placeholder="$t('select_vehicle_brand')"
                v-model="uploadData.vehicle_brand" v-validate="'required'" name="vehicle brand"
                @change="brandChanged($event)">
                <el-option v-for="vehiclebrand in vehicleData.brands" class="select-primary" :value="vehiclebrand.id"
                  :label="vehiclebrand.name" :key="vehiclebrand.id"></el-option>
              </el-select>
              <el-select :class="{
                'select-warning': !uploadData.vehicle_series,
                'select-success': uploadData.vehicle_series,
              }" class="col-md-4" size="large" :placeholder="$t('select_vehicle_series')"
                v-model="uploadData.vehicle_series" v-validate="'required'" name="vehicle series"
                @change="serieChanged($event)">
                <el-option v-for="vehicleseries in vehicleData.series" class="select-primary" :value="vehicleseries.id"
                  :label="vehicleseries.name" :key="vehicleseries.id"></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group" v-else>
              <label class="col-md-4 control-label">{{ $t('vehicle_brand_series') }}</label>
              <div class="col-md-4">
              <input type="text" v-model="uploadData.manual_vehicle_brand" name="manual_vehicle_brand" placeholder="Brand" v-validate="'required'"
                  :class="{
                    'input-required': !uploadData.manual_vehicle_brand,
                    'input-success': uploadData.manual_vehicle_brand,
                  }" class="form-control" />
                  </div>
              <div class="col-md-4">
              <input type="text" v-model="uploadData.manual_vehicle_series" name="manual_vehicle_series" placeholder="Serie" v-validate="'required'"
                  :class="{
                    'input-required': !uploadData.manual_vehicle_series,
                    'input-success': uploadData.manual_vehicle_series,
                  }" class="form-control" />
                  </div>
              <div class="clearfix"></div>
            </div>

            <div class="form-group" v-if="!manualData">
              <label class="col-md-4 control-label">{{ $t('vehicle_build_engine') }}</label>
              <el-select :class="{
                'select-warning': !uploadData.vehicle_build,
                'select-success': uploadData.vehicle_build,
              }" class="col-md-4" size="large" :placeholder="$t('select_vehicle_model')"
                v-model="uploadData.vehicle_build" v-validate="'required'" name="vehicle build"
                @change="buildChanged($event)">
                <el-option v-for="vehiclebuild in vehicleData.builds" class="select-primary" :value="vehiclebuild.id"
                  :label="vehiclebuild.name" :key="vehiclebuild.id"></el-option>
              </el-select>
              <el-select :class="{
                'select-warning': !uploadData.vehicle_engine,
                'select-success': uploadData.vehicle_engine,
              }" class="col-md-4" size="large" :placeholder="$t('select_vehicle_engine')"
                v-model="uploadData.vehicle_engine" v-validate="'required'" name="vehicle build">
                <el-option v-for="engine in vehicleData.engines" class="select-primary" :value="engine.id"
                  :label="engine.name + ' [' + engine.hp + ' hp]'" :key="engine.id"></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group" v-else>
              <label class="col-md-4 control-label">{{ $t('vehicle_build_engine') }}</label>
              <div class="col-md-4">
              <input type="text" v-model="uploadData.manual_vehicle_build" name="manual_vehicle_build" :placeholder="$t('select_vehicle_model')" v-validate="'required'"
                  :class="{
                    'input-required': !uploadData.manual_vehicle_build,
                    'input-success': uploadData.manual_vehicle_build,
                  }" class="form-control" />
                  </div>
              <div class="col-md-4">
              <input type="text" v-model="uploadData.manual_vehicle_engine" name="manual_vehicle_engine" :placeholder="$t('vehicle_engine')" v-validate="'required'"
                  :class="{
                    'input-required': !uploadData.manual_vehicle_engine,
                    'input-success': uploadData.manual_vehicle_engine,
                  }" class="form-control" />
                  </div>
              <div class="clearfix"></div>
            </div>
            <div class="col-md-12 text-center"><p-switch v-model="manualData" type="primary" on-text="ON" off-text="OFF"></p-switch>
              <span>Enter manually</span>
            </div>
            <div class="clearfix"></div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("year_and_vin")
              }}</label>
              <div class="col-md-4">
                <input type="number" v-model="uploadData.year" name="year" placeholder="0000" v-validate="'required'"
                  :class="{
                    'input-required': !uploadData.year,
                    'input-success': uploadData.year,
                  }" class="form-control" />
              </div>
              <div class="col-md-1">
                <p-switch v-model="isVIN" type="primary" on-text="VIN" off-text="REG"></p-switch>
              </div>
              <div class="col-md-3">
                <input type="text" name="vin" v-model="uploadData.vin" :placeholder="$t('vin_or_registration')"
                  class="form-control" v-validate="'required'" :class="{
                    'input-required': !uploadData.vin,
                    'input-success': uploadData.vin,
                  }" />
              </div>

              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("hp_transmission")
              }}</label>
              <div class="col-md-4">
                <input type="number" name="hp" placeholder="0" class="form-control"
                  v-model="uploadData.vehicle_data_hp" v-validate="'required'" />
              </div>
              <el-select :class="{
                'select-warning': !uploadData.transmission_type,
                'select-success': uploadData.transmission_type,
              }" class="col-md-4" size="large" :placeholder="$t('select_transmission_type')"
                v-model="uploadData.transmission_type" v-validate="'required'" name="transmission">
                <el-option v-for="type in transmissionTypes" 
                class="select-primary" :value="type.name" :label="type.name"
                  :key="type.name">
                  </el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{ $t('ecu_specifications') }}</label>
              <div v-if="!manualInput.ecu_brand">
                <el-select :class="{
                  'select-warning': !uploadData.ecu_brand,
                  'select-success': uploadData.ecu_brand,
                }" class="col-md-2" size="large" v-model="uploadData.ecu_brand" :placeholder="$t('select_ecu_brand')"
                  v-validate="'required'" name="ECU brand" @change="loadEcuModels($event)">
                  <el-option class="select-primary" value="other" :label="$t('other_unknown')"></el-option>
                  <el-option v-for="ecuItem in ecuBrandList" class="select-primary" :value="ecuItem.id"
                    :label="ecuItem.name" :key="ecuItem.id"></el-option>
                </el-select>
              </div>
              <div class="col-md-2" v-else>
                <input type="text" name="vin" v-model="uploadData.ecu_brand" :placeholder="$t('manually_enter_ecu_brand')"
                  class="form-control" v-validate="'required'" />
              </div>

              <div class="switchToManualButton">
                <a href="#" @click="
                  manualInput.ecu_brand = !manualInput.ecu_brand;
                uploadData.ecu_brand = '';
                                    "><i class="fas fa-edit"></i></a>
              </div>
              <div v-if="!manualInput.ecu_model">
                <el-select :class="{
                  'select-warning': !uploadData.ecu_model,
                  'select-success': uploadData.ecu_model,
                }" class="col-md-2" size="large" v-model="uploadData.ecu_model" :placeholder="$t('select_ecu_model')"
                  v-validate="'required'" name="ECU model" @change="loadEcuTypes($event)">
                  <el-option class="select-primary" value="other" :label="$t('other_unknown')"></el-option>
                  <el-option v-for="ecuItem in ecuModelList" class="select-primary" :value="ecuItem.id"
                    :label="ecuItem.name" :key="ecuItem.id"></el-option>
                </el-select>
              </div>
              <div class="col-md-2" v-else>
                <input type="text" name="ecu_model" v-model="uploadData.ecu_model"
                  :placeholder="$t('manually_enter_ecu_model')" class="form-control" v-validate="'required'" />
              </div>
              <div class="switchToManualButton">
                <a href="#" @click="
                  manualInput.ecu_model = !manualInput.ecu_model;
                uploadData.ecu_model = '';
                                    "><i class="fas fa-edit"></i></a>
              </div>
              <div v-if="!manualInput.ecu_type">
                <el-select :class="{
                  'select-warning': !uploadData.ecu_type,
                  'select-success': uploadData.ecu_type,
                }" class="col-md-4" size="large" v-model="uploadData.ecu_type" v-validate="'required'"
                  :placeholder="$t('select_ecu_type')" name="ECU type">
                  <el-option class="select-primary" value="other" :label="$t('other_unknown')"></el-option>
                  <el-option v-for="ecutype in ecuTypeList" class="select-primary" :value="ecutype.id"
                    :label="ecutype.name" :key="ecutype.id"></el-option>
                </el-select>
              </div>
              <div class="col-md-2" v-else>
                <input type="text" name="ecu_type" v-model="uploadData.ecu_type"
                  v-validate="{ 'required': !iniFileUploaded }" :placeholder="$t('manually_enter_ecu_type')"
                  class="form-control" />
              </div>
              <div class="switchToManualButton">
                <a href="#" @click="
                  manualInput.ecu_type = !manualInput.ecu_type;
                uploadData.ecu_type = '';
                                    "><i class="fas fa-edit"></i></a>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("hardware_numbers")
              }}</label>
              <div class="col-md-4">
                <input type="text" name="hw number 1" v-model="uploadData.hw_1" placeholder="Hardware #1"
                  class="form-control" />
              </div>
              <div class="col-md-4">
                <input type="text" name="hw number 2" v-model="uploadData.hw_2" placeholder="Hardware #2"
                  class="form-control" />
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{ $t('software_numbers') }}</label>
              <div class="col-md-4">
                <input type="text" name="sw number 1" v-model="uploadData.sw_1" placeholder="Software #1"
                  class="form-control required" v-validate="'required'" :class="{
                    'input-required': !uploadData.sw_1,
                    'input-success': uploadData.sw_1,
                  }" />
              </div>
              <div class="col-md-4">
                <input type="text" name="sw number 2" v-model="uploadData.sw_2" placeholder="Software #2"
                  class="form-control" />
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{ $t('read_method_tuning_tool') }}</label>
              <el-select :class="{
                'select-warning': !uploadData.read_method,
                'select-success': uploadData.read_method,
              }" class="col-md-4" size="large" :placeholder="$t('select_read_method')"
                v-model="uploadData.read_method" v-validate="'required'" name="Read method">
                <el-option v-for="method in readMethods" class="select-primary col-md-6" :value="method.name"
                  :label="method.name" :key="method.name"></el-option>
              </el-select>
              <el-select :class="{
                'select-warning': !uploadData.tuning_tool,
                'select-success': uploadData.tuning_tool,
              }" class="col-md-4" size="large" :placeholder="$t('select_tuning_tool')"
                v-model="uploadData.tuning_tool" v-validate="'required'" name="tuning tool">
                <el-option v-for="tool in tuningTools" class="select-primary" :value="tool.id" :label="tool.name"
                  :key="tool.id"></el-option>
              </el-select>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <label class="col-md-4 control-label">{{
                $t("tool_type_terms_conditions")
              }}</label>
              <el-select :class="{
                'select-warning': !uploadData.tool_type,
                'select-success': uploadData.tool_type,
              }" class="col-md-4" size="large" :placeholder="$t('select_tool_type')" v-model="uploadData.tool_type"
                v-validate="'required'" name="Tool type">
                <el-option v-for="tooltype in tuningToolTypes" class="select-primary" :value="tooltype.name"
                  :label="tooltype.name" :key="tooltype.name"></el-option>
              </el-select>
              <p-switch v-model="uploadData.accept_terms" class="termsConditions">
                <i class="fa fa-check" slot="on"></i>
                <i class="fa fa-times" slot="off"></i>
              </p-switch>
              <a class="alert" href="/static/terms-conditions.pdf" target="_blank">
                {{ $t("accept_terms") }}
                <i class="fas fa-external-link-alt"></i>
              </a>
              <div class="clearfix"></div>
            </div>
            <div class="form-group">
              <ul>
                <li v-show="errors.has('tuning type')" class="invalid-feedback">
                  {{ errors.first("tuning type") }} (one or more allowed)
                </li>
                <li v-show="errors.has('vehicle type')" class="invalid-feedback">
                  {{ errors.first("vehicle type") }}
                </li>
                <li v-show="errors.has('vehicle brand')" class="invalid-feedback">
                  {{ errors.first("vehicle brand") }}
                </li>
                <li v-show="errors.has('vehicle series')" class="invalid-feedback">
                  {{ errors.first("vehicle series") }}
                </li>
                <li v-show="errors.has('vehicle build')" class="invalid-feedback">
                  {{ errors.first("vehicle build") }}
                </li>
                <li v-show="errors.has('transmission')" class="invalid-feedback">
                  {{ errors.first("transmission") }}
                </li>
                <li v-show="errors.has('ECU brand')" class="invalid-feedback">
                  {{ errors.first("ECU brand") }}
                </li>
                <li v-show="errors.has('ECU type')" class="invalid-feedback">
                  {{ errors.first("ECU type") }}
                </li>
                <li v-show="errors.has('sw number 1')" class="invalid-feedback">
                  {{ errors.first("sw number 1") }}
                </li>
              </ul>
              <hr />
              <h5 v-show="errors.any()" class="invalid-feedback text-center">
                {{ $t("not_all_fields_entered") }}
              </h5>
              <br />
              <br />
              <div v-if="insufficientCredits">Your credit balance is insufficient. Please buy more credits to continue.</div>
              <div v-else>
              <button type="button" @click="process()" id="submitButton" class="btn btn-block btn-success" disabled
                :data-tooltip="$t('upload_some_files_first')">
                <i class="fa" :class="{
                  'fa-upload': !uploadingFile,
                  'fa-circle-o-notch fa-spin fa-fw': uploadingFile,
                }" :disabled="uploadingFile" aria-hidden="true"></i>
                <div v-if="filesUploadedSuccess">
                  {{ $t("complete_your_file_request") }}
                </div>
                <div v-else-if="filesBeingUploaded">
                  {{ $t("please_wait_files_uploaded") }}
                </div>
                <div v-else>{{ $t("select_files_to_upload") }}</div>
              </button>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Input, Button, Select, Option, DatePicker } from "element-ui";
import swal from "sweetalert2";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import PSwitch from "src/components/UIComponents/Switch.vue";
export default {
  props: ["fileId"],
  components: {
    vueDropzone: vue2Dropzone,
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    PSwitch,
  },
  data: function () {
    return {
      manualData: true,
      insufficientCredits: false,
      user: {
        credits: 0
      },
      tuningTypes: "",
      priorities: "",
      selectableChildren: "",
      selectedChildren: [],
      brandLogoSrc: "/static/img/empty_brand.png",
      serieImageSrc: "",
      vehicleData: {
        types: {},
        brands: {},
        series: {},
        builds: {},
        engines: {},
      },
      uploadingFile: false,
      fileData: "",
      customerData: "",
      productData: "",
      isVIN: true,
      ecuData: {
        brand: "",
        model: "",
        type: "",
      },
      uploadData: {
        tuning_type: "",
        additional_tuning: "",
        vehicle_type: "cars",
        files: "",
        ecu_brand: "",
        ecu_model: "",
        ecu_type: "",
        vehicle_data_hp: "",
        tool_type: "",
        accept_terms: false,
        tuning_type_children: "",
        tuning_tool: "",
        order_number: "",
      },
      ecuBrandList: "",
      ecuModelList: "",
      ecuTypeList: "",
      transmissionTypes: [
        { name: "manual" },
        { name: "automatic" },
        { name: "dsg" },
        { name: "dct" },
        { name: "other" },
      ],
      readMethods: [
        { name: "OBD" },
        { name: "BENCH" },
        { name: "BOOTMODE" },
        { name: "BDM" },
        { name: "other" },
      ],
      tuningTools: "",
      tuningToolTypes: [
        { name: "MASTER" },
        { name: "SLAVE" },
        { name: "Other / Unknown" },
      ],
      selectedTuningType: "",
      selectedPriority: "",
      additionalTuningtypes: "",
      columns: ["fuel_type", "name", "slug", "hp", "kw", "actions"],
      dropzoneOptions: {
        addRemoveLinks: true,
        paramName: "files",
        url: APIURL + "/files/upload",
        maxNumberOfFiles: 5,
        uploadMultiple: true,
        parallelUploads: 3,
        thumbnailWidth: 100,
        maxFilesize: 25,
        timeout: 180000,
        dictDefaultMessage:
          "<h3><i class='fa fa-cloud-upload-alt fa-1x' style=\"width:50px;\"></i><br/>"+ this.$t('Click or drag here to add files') +"</h3>",
        headers: {
          Authorization: "Bearer " + Ls.get("access_key"),
          "CTR-Access-Key": SITEKEY,
        },
      },
      calculatedTotalCredits: 0,
      filesBeingUploaded: false,
      filesUploadedSuccess: false,
      manualInput: {
        ecu_brand: false,
        ecu_model: false,
        ecu_type: false,
      },
    };
  },
  mounted: function () {
    this.loadVehicleTypes();
    this.loadTuningTypes();
    this.loadBrands("cars");
    this.loadTuningTools();
    this.loadEcuBrands();
    if (this.$route.params.brand_id) {
      this.loadAutomatically();
    }
    this.user = Webservice.getUser().then(response => {
      if (response.data) {
        this.user = response.data;
      }
    });
  },
  methods: {
    goBack() {
      $("html, body").animate({ scrollTop: 0 }, "fast");
      $('.nav-tabs a[href="#overviewTab"]').tab("show");
    },
    checkCreditSufficiency() {
      if((this.user) && (this.calculateTotalCredits > this.user.credits)) {
        this.insufficientCredits = true;
        this.$notify({
          component: {
            template:
              "<span>" +
              this.$t("your_credits_are_too_low_for_specified_options_buy_new") +
              "</span>",
          },
          icon: "fas fa-exclamation-circle",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
        });
      } else {
        this.insufficientCredits = false;
      }
    },
    tuningTypeChanged(event) {
      this.selectableChildren = ""; this.selectedChildren = [];
      var result = _.find(this.tuningTypes, (item) => {
        if (item.id == event) {
          if (item.children) {
            this.selectableChildren = item.children;
          } else {
            this.selectableChildren = [];
          }
          return item;
        }
      });
      this.selectedTuningType = result;
      this.checkCreditSufficiency();
      
    },
    priorityChanged(event) {
      var result = _.find(this.priorities, (item) => {
        if (item.id == event) {
          return true;
        }
      });
      this.selectedPriority = result;
      this.checkCreditSufficiency();
    },
    loadVehicleTypes() {
      Webservice.getVehicleTypes().then((resp) => {
        this.vehicleData.types = resp.data;
      });
    },
    loadTuningTypes() {
      if (!this.tuningTypes) {
        Webservice.getProducts("chiptuning").then((resp) => {
          this.tuningTypes = resp.data;
        });
        Webservice.getProducts("priorities").then((resp) => {
          this.priorities = resp.data;
        });
      }
    },
    loadTuningTools() {
      Webservice.getTuningtools().then((resp) => {
        this.tuningTools = resp.data;
      });
    },
    loadEcuBrands() {
      if (!this.ecuBrandList) {
        Webservice.getEcuBrands().then((resp) => {
          this.ecuBrandList = resp.data;
        });
      }
    },
    loadEcuModels(event) {
      Webservice.getEcuModels(event).then((resp) => {
        this.ecuModelList = resp.data;
        this.loadEcuTypes(null, event);
      });
    },
    loadEcuTypes(model_id, brand_id) {
      Webservice.getEcuTypes(model_id, brand_id).then((resp) => {
        this.ecuTypeList = resp.data;
      });
    },
    loadBrands(evt) {
      if (typeof evt == "object") {
        var type = evt.target.value;
      } else {
        var type = evt;
      }
      Webservice.getBrands(type).then((resp) => {
        this.vehicleData.brands = resp.data;
      });
    },
    brandChanged(brandId) {
      Webservice.getBrandImage(brandId).then((response) => {
        if (response.status == 200) {
          this.brandLogoSrc =
            "data:image/png;base64," +
            new Buffer(response.data, "binary").toString("base64");
        }
      });
      Webservice.getSeries(brandId).then((resp) => {
        this.vehicleData.series = resp.data;
      });
    },
    serieChanged(serieId) {
      Webservice.getSerieImage(serieId).then((response) => {
        if (response.status == 200) {
          this.serieImageSrc =
            "data:image/png;base64," +
            new Buffer(response.data, "binary").toString("base64");
        }
      });
      Webservice.getBuilds(serieId).then((resp) => {
        this.vehicleData.builds = resp.data;
      });
    },
    buildChanged(buildId) {
      Webservice.getEngines(buildId).then((resp) => {
        this.vehicleData.engines = resp.data;
      });
    },
    uploadUploading(file, response) {
      this.filesBeingUploaded = true;
    },
    uploadSuccess(file, response) {
      if (response) {
        this.filesUploadedSuccess = true;
        this.uploadData.files = response;
        $("#submitButton").prop("disabled", false);
        $("#submitButton").attr("data-tooltip", this.$t("complete_request"));
        this.$notify({
          component: {
            template: "<span>" + this.$t("file_upload_succeeded") + "</span>",
          },
          icon: "fas fa-check",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success",
        });
      }
    },
    process() {
      if (this.uploadData.accept_terms == false) {
        swal({
          title: this.$t("accept_terms_before_continue"),
          buttonsStyling: false,
          confirmButtonClass: "btn btn-success btn-fill",
          html: this.$t("please_read_clicking_link"),
        });
        return false;
      }
      this.$validator.validateAll().then((result) => {
        if (result === true) {
          this.uploadData.tuning_type_children =
            this.getSelectedChildrenTuningTypes();
          if (this.uploadData.order_number) {
            this.uploadData.message =
              "[OrderNo: " +
              this.uploadData.order_number +
              "] " +
              this.uploadData.message;
          }
          Webservice.processUpload(this.uploadData)
            .then((response) => {
              this.$notify({
                component: {
                  template:
                    "<span>" + this.$t("processing_completed") + "</span>",
                },
                icon: "fas fa-check",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "success",
              });
              this.$refs.uploadZone.removeAllFiles();
              this.uploadData = {
                tuning_type: "",
                additional_tuning: "",
                vehicle_type: "cars",
                files: "",
                ecu_brand: "",
                ecu_model: "",
                ecu_type: "",
                tool_type: "",
                vehicle_data_hp: "",
                accept_terms: false,
                message: "",
              };
              this.brandLogoSrc = "";
              this.serieImageSrc = "";
              this.selectedChildren = [];
              // emit updates and show overview
              this.$emit("update:loadedFileStatus", "saved");
              this.$emit("fileUploaded");
            })
            .catch((error) => {
              this.$notify({
                component: {
                  template:
                    "<span>" +
                    this.$t("something_went_wrong_retry") +
                    "</span>",
                },
                icon: "fas fa-exclamation-circle",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "warning",
              });
            });
        } else {
          this.toastr.warning(
            this.$t("not_all_fields_entered_retry"),
            this.$t("validation_failed")
          );
        }
      });
    },
    readTicketmessage(ticketId) {
      this.$router.push({ name: "tickets", params: { ticketId: ticketId } });
    },

    showTermsConditions() {
      Webservice.getTermsConditions()
        .then((resp) => {
          if (resp.data) {
            swal({
              html: resp.data,
              width: 800,
            });
          }
        })
        .catch((error) => {
          this.$notify({
            component: {
              template:
                `<span>` + this.$t("error_terms_conditions") + `</span>`,
            },
            icon: "ti-info",
            type: "error",
          });
        });
    },
    getSelectedChildrenTuningTypes() {
      var selectedItems = [];
      _.each(this.selectedChildren, (childItem) => {
        selectedItems.push(this.selectableChildren[childItem].id);
      });
      /** Also process prio's */
      if (typeof this.selectedPriority !== "undefined") {
        selectedItems.push(this.selectedPriority.id);
      }
      return selectedItems;
    },
    loadAutomatically() {
      const queryString = window.location.search;
      console.log(queryString);
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.get("brand_id")) {
        this.brandChanged(urlParams.get("brand_id"));
      }
      console.log(this.$route.params);
    },
  },
  computed: {
    // a computed getter
    calculateTotalCredits: function () {
      var totalCredits = 0;
      if (this.selectedTuningType.credits) {
        totalCredits = parseInt(this.selectedTuningType.credits);
      }
      if ((this.selectedPriority) && (this.selectedPriority.credits)) {
        totalCredits += parseInt(this.selectedPriority.credits);
      }
      if(this.selectedChildren) {
        _.each(this.selectedChildren, (childItem) => {
          totalCredits += this.selectableChildren[childItem] ? parseInt(this.selectableChildren[childItem].credits) : 0;
        });
      }
      return totalCredits;
    },
  },
};
</script>
<style scoped>
.bootstrap-switch {
  margin-top: 5px;
  margin-left: 25px;
}

.switchToManualButton {
  width: 0px;
  float: left;
  margin-left: -16px;
  margin-top: -10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/upload.vue